import styled from 'styled-components';
import { Box } from '@mui/material';

export const CustomerStatusWrapper = styled(Box)`
display: flex;
width: 100%;
    justify-content: space-between;
.d-flex{
    border: 1px solid #1B4A83;
        padding: 20px 0px;
    flex-wrap: wrap;
        width: 100%;
border-radius: 5px;
  img{
      display: flex;
  }
    .customerDetails{
        width: 25%;
            text-align: start;
    display: flex;
      .imgIcon{
          
    margin: 18px 0 0px 20px;
     
    }
    .h4padding{
        padding-left: 0px;
    }
    .contentUser{
        padding: 0 10px;
            margin: 17px 0;
            h4{
                color: #1B4A83;
                font-size: 18px;
                margin: 0;
                font-weight: 500;

            }
            p{
                color: #2A2725;
                font-weight: 600;
                margin: 0;
                font-size: 18px;
            }
            .customDropdown {
              width: 250px;
              font-weight: 600;
            }
    }
}


`;

          